<template>
  <g fill-rule="evenodd">
    <path
      d="M16.14 14.25a.6.6 0 01-.54.35H4.01a.61.61 0 01-.47-1L4.87 12a4 4 0 00.93-2.56V8.2c0-1.77 1.15-3.5 2.67-4.04A.8.8 0 009 3.4v-.8a.8.8 0 01.94-.79c.4.1.67.47.66.88v.71c0 .34.2.64.52.75A4.33 4.33 0 0113.8 8.2v1.24c0 .94.33 1.84.93 2.56l1.33 1.6a.6.6 0 01.08.65zM9.8 17.8a1.6 1.6 0 01-1.6-1.6h3.2c0 .89-.72 1.6-1.6 1.6zm7.49-5.22l-1.33-1.6a2.4 2.4 0 01-.56-1.54V8.2c0-2.25-1.3-4.36-3.2-5.32v-.2a2.47 2.47 0 00-2-2.45A2.4 2.4 0 007.4 2.6v.27A6.04 6.04 0 004.2 8.2v1.24c0 .57-.2 1.1-.56 1.54l-1.32 1.6a2.21 2.21 0 001.7 3.62H6.6a3.2 3.2 0 006.4 0h2.6a2.2 2.2 0 001.7-3.62h-.01zM1.8 9a.8.8 0 00.8-.8c0-1.4.42-2.78 1.2-3.95l.27-.4a.8.8 0 00-1.33-.89l-.27.4A8.69 8.69 0 001 8.2c0 .44.36.8.8.8M18.6 8.2c0-1.72-.5-3.4-1.47-4.84l-.26-.4a.8.8 0 00-1.34.89l.27.4A7.12 7.12 0 0117 8.2a.8.8 0 001.6 0"
    />
  </g>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "NotificationMenuIcon",
});
</script>
